import { Stack } from "@mantine/core";

import PageWrapper from "../../../components/Page/PageWrapper";
import PageTitle from "../../../components/Page/PageTitle";
import { QueryBuilder } from "../../../components/QueryBuilder";
import Loader from "../../../components/loader/loader";

import { useRuleEditor } from "./useRuleEditor.logic";
import RuleEditorHeader from "./components/RuleEditorHeader";
import TestResultsTable from "./components/TestResultsTable/TestResultsTable";
import { useTranslation } from "react-i18next";

/**
 * The editable Rule dashboard.
 *
 * Mounted at /rules/rule-dashboard/:id. The :id flows in via
 * useRuleEditor; QueryBuilder owns rule loading and the canvas
 * itself, while this page owns the page chrome (header + Details
 * modal + Test results table).
 */
export default function RuleEditor() {
  const { ruleId } = useRuleEditor();
  const { t } = useTranslation();

  if (!ruleId) {
    return (
      <PageWrapper>
        <Loader height="40vh" />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.rule")} />
      <Stack gap="lg">
        <RuleEditorHeader ruleId={ruleId} />
        <QueryBuilder ruleId={ruleId} />
        <TestResultsTable ruleId={ruleId} />
      </Stack>
    </PageWrapper>
  );
}
